module.exports = __webpack_public_path__ + "static/studio-05-e8ce872133a656b34d777b47e36542bb.webp";